export const isRoleAccount = [
  143429, 143459, 143426, 135126, 141225, 143457, 143463, 143464, 143465,
  143462, 143425, 143430, 143458, 143450,
];

export const isRoleSelf = [135300];
